<div
  *ngIf="!loading"
  [class.ks-dialog]="isDialog"
  [class.ks-py-0]="!isDialog"
  class="ks-file-input ks-card"
>
  <header *ngIf="isDialog" class="ks-card-header">
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="close()"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main [class.ks-py-0]="isDialog" class="ks-card-body ks-m-0">
    <div
      (drop)="handleFiles($event); fileOver = false"
      (dragover)="stopEvent($event); fileOver = true"
      (dragleave)="stopEvent($event); fileOver = false"
      class="ks-file-drop-area ks-bg-{{ fileOver ? 'light' : 'lighter' }}-{{
        color
      }} ks-mb-4 ks-px-6 ks-py-4"
    >
      <span inlineSVG="assets/icons/Upload-cloud.svg" class="ks-text-{{ color }} ks-mb-4"></span>
      <p class="ks-body-md ks-font-weight-bold ks-text-center ks-text-neutral ks-mb-4">
        {{ text }}
      </p>
      <button class="ks-btn-sm ks-btn-{{ color }}" (click)="fileInput.click()">
        {{ browseLabel }}
      </button>
      <input
        #fileInput
        hidden
        type="file"
        [multiple]="multiple"
        [accept]="type"
        (change)="handleFiles($event)"
      />
    </div>
    <div class="ks-file-submit">
      <kt-input
        [type]="'text'"
        [placeholder]="'No files selected'"
        [control]="namesControl"
        [errors]="errors"
        [readonly]="true"
      ></kt-input>
      <button class="ks-btn-sm ks-btn-outline-{{ color }}" (click)="submit()">
        {{ submitLabel }}
      </button>
    </div>
  </main>
</div>
